<template>
  <custom-callout
    border-color="primary-2"
    class="mb-4 custom-callout rounded"
    :has-toggle="false"
  >
    <div class="py-1">
      <div class="d-flex">
        <icon-view
          class="mt-5 mb-2 mt-md-0 mt-sm-5 ml-3"
          :gradient="false"
          icon="fas fa-file-invoice mb-1"
          icon-background="#ffff"
          icon-color="#ff7058"
          icon-size="16px"
          :title="title"
        />
      </div>
      <div class="pl-4">
        <validation-observer ref="studendObserver">
          <div class="row my-3">
            <div class="col-md-3 col-sm-12">
              <validation-provider
                v-slot="{ errors }"
                :custom-messages="{
                  required: 'El número de SIE es requerido.',
                  studentSie: 'El número de SIE no es válido.',
                }"
                rules="required|studentSie"
              >
                <custom-input
                  v-model="studentSie"
                  :error="errors[0]"
                  label="Número de Estudiante:"
                  mask-type="SIE"
                  placeholder="Escriba número de SIE"
                />
              </validation-provider>
            </div>

            <div class="col-md-3 col-sm-12  pt-2 ">
              <div class="mt-4">
                <action-button
                  i="fas fa-search"
                  text="Buscar"
                  variant="success pl-3 pr-3 mr-3"
                  @click="searchStudent"
                />
                <action-button
                  v-if="!showStudendSection"
                  i="fas fa-times-circle"
                  text="Cancelar"
                  variant="outline-danger pl-3 pr-3"
                  @click="onClose"
                />
              </div>
            </div>
          </div>
        </validation-observer>

        <div v-if="showStudendSection && student.fullName">
          <div class="row">
            <div class="col-md-12 text-bold bold mb-3 mt-2">
              <i class=" fa fa-info-circle color-orange" />
              Información de Estudiante
            </div>

            <div class="col-md-12 text-bold bold mb-3 mt-2 pr-5">
              <div class="container-student pb-3 pl-3">
                <div class="row">
                  <div class="col-12 col-md-2 pt-4">
                    <div class=" ml-2 regular text-gray">
                      Nombre del Estudiante:
                    </div>
                    <div class=" ml-2 regular color-black">
                      {{ student.fullName }}
                    </div>
                  </div>
                  <div class="col-12 col-md-2 pt-4">
                    <div class=" ml-2 regular text-gray">
                      SIE:
                    </div>
                    <div class=" ml-2 regular color-black">
                      {{ studentSie }}
                    </div>
                  </div>
                  <div class="col-12 col-md-2 pt-4">
                    <div class=" ml-2 regular text-gray">
                      Edad:
                    </div>
                    <div class=" ml-2 regular color-black">
                      {{ getAge }}
                    </div>
                  </div>
                  <div class="col-12 col-md-2 pt-4">
                    <div class=" ml-2 regular text-gray">
                      Fecha de Nacimiento:
                    </div>
                    <div class=" ml-2 regular color-black">
                      {{ student.birthdate | date }}
                    </div>
                  </div>
                  <div class="col-12 col-md-2 pt-4">
                    <div class=" ml-2 regular text-gray">
                      NSS:
                    </div>
                    <div class=" ml-2 regular color-black">
                      {{ student.ssn }}
                    </div>
                  </div>
                  <div class="col-12 col-md-2 pt-4">
                    <div class=" ml-2 regular text-gray">
                      Estatus:
                    </div>
                    <div class=" ml-2 regular color-black">
                      {{ student.status | empty }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr class="mr-4" />
          <validation-observer ref="infoTapRequestObserver">
            <div class="row">
              <div class="col-md-2 col-sm-12 mr-md">
                <validation-provider v-slot="{ errors }" :rules="'required'">
                  <custom-drop-down
                    v-model="academicYear"
                    :custom-error-msg="'El año académico es requerido.'"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    label="Año Académico:"
                    :options="filters.academicYears"
                    placeholder="Seleccione"
                  />
                </validation-provider>
              </div>
              <div class="col-md-3 col-sm-12 mr-md">
                <validation-provider v-slot="{ errors }" :rules="'required'">
                  <custom-drop-down
                    v-model="municipality"
                    :custom-error-msg="'El municipio es requerido.'"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    label="Municipio de Residencia:"
                    :options="filters.municipalities"
                    placeholder="Seleccione"
                  />
                </validation-provider>
              </div>
              <div class="col-md-3 col-sm-12 mr-md">
                <validation-provider v-slot="{ errors }" :rules="'required'">
                  <custom-drop-down
                    v-model="requestType"
                    :custom-error-msg="'La determinación es requerida'"
                    :disabled="true"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    label="Determinación:"
                    :options="filters.requestTypes"
                    placeholder="Seleccione"
                  />
                </validation-provider>
              </div>

              <div class="col-md-4 col-sm-12  pt-2 ">
                <div class="mt-4  ">
                  <action-button
                    i="fas fa-times-circle"
                    text="Cancelar"
                    variant="outline-danger mr-3 pl-3 pr-4"
                    @click="onClose"
                  />
                  <action-button
                    i="fas fa-arrow-alt-circle-right"
                    text="Continuar"
                    variant="success pl-3 pr-3"
                    @click="onContinue()"
                  />
                </div>
              </div>
            </div>
          </validation-observer>
        </div>
      </div>
      <br />
    </div>
    <custom-modal
      cancel-text="No"
      icon="fas fa-bell-exclamation"
      is-centered
      save-text="Si"
      :show-cancel="false"
      :show-save="false"
      :show-with-shadow="true"
      title="Confirmación"
      :value="showModal"
      width="500px"
    >
      <div class="container-modal ml-3 mr-3 mt-4 mb-5">
        El número de consulta ha sido creado con el número
        <b>{{ tapRequestNumber }}</b>
        favor anotarlo para la creación de la solicitud de reembolso
      </div>
      <div class="d-flex justify-content-center  ">
        <action-button
          i="fas fa-copy"
          text="Copiar"
          variant="success pl-3 pr-3"
          @click="copy()"
        />
      </div>
    </custom-modal>
  </custom-callout>
</template>
<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';
import CustomDropDown from 'custom-drop-down';
import IconView from 'icon-view';
import CustomModal from 'CustomModal';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import {
  getStudent as _getStudent,
  getInitFiltersCreateTap as _getInitFiltersCreateTap,
  createConversionTapRequest as _createconversiontaprequest,
} from '@/modules/reinbursement/api.js';
import alertMixin from '@/mixins/alert.mixin.js';
import dateUtils from '@/utils/dateUtils';
export default {
  name: 'AddConsultation',
  components: {
    IconView,
    ActionButton,
    CustomInput,
    CustomDropDown,
    CustomCallout,
    CustomModal,
    ValidationObserver,
    ValidationProvider,
  },
  mixins: [alertMixin],
  props: {
    defaultComment: {
      type: String,
      default: () => '',
    },
    title: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    showStudendSection: false,
    studentSie: null,
    filters: null,
    student: null,
    academicYear: null,
    showModal: false,
    requestType: { id: 2, name: 'Reembolso' },
    municipality: null,
    tapRequestNumber: null,
  }),
  computed: {
    getAge() {
      return dateUtils.calculateAge(this.student.birthdate);
    },
  },

  async created() {
    const { data } = await _getInitFiltersCreateTap();
    this.filters = data;
  },
  methods: {
    onClose() {
      this.$emit('on-close');
      this.showStudendSection = false;
    },
    async onContinue() {
      this.uploadData();
      this.$emit('on-continue');
    },
    async searchStudent() {
      const isValid = await this.$refs.studendObserver.validate();
      if (isValid) {
        const { data } = await _getStudent(this.studentSie);
        this.student = data;
        if (!this.student.fullName) {
          this.ShowToast(
            'Error',
            'El número de SIE no se encontró en sistema.',
            'error'
          );
        } else {
          this.showStudendSection = true;
        }
      } else {
        return;
      }
    },
    copy() {
      navigator.clipboard.writeText(`${this.tapRequestNumber}`);
      this.ShowToast(
        'Proceso Exitoso',
        'Número de consulta ha sido copiado exitosamente',
        'success'
      );
      this.showModal = false;
      this.onClose();
    },
    async uploadData() {
      const isValid = await this.$refs.infoTapRequestObserver.validate();
      if (isValid) {
        let payload = {
          determinationType: this.requestType.id,
          academicYearId: this.academicYear.id,
          studentSieId: parseFloat(this.studentSie),
          municipalityId: this.municipality.id,
        };

        const { data } = await _createconversiontaprequest(payload);

        if (!data.isvalid) {
          this.ShowToast('Error', data.errors[0], 'error');
        } else {
          this.tapRequestNumber = data.tapRequestNumber;
          this.showModal = true;
        }
      } else {
        this.ShowToast(
          'Error',
          'Favor de completar la información requerida',
          'error'
        );
      }
    },
  },
};
</script>
<style scoped lang="scss">
.container-student {
  border-radius: 5px;
  border-left: 5px solid #b5c3bc;
  background-color: white;
}
.container-modal {
  border-radius: 5px;
  background-color: #f2f2f2;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
}
.pr-33-px {
  padding-right: 33px;
}
</style>
